import { render, staticRenderFns } from "./dashboard-member.vue?vue&type=template&id=61f81c38&"
import script from "./dashboard-member.vue?vue&type=script&lang=js&"
export * from "./dashboard-member.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports